/* @flow */
import Form from 'components/Form.jsx';
import FormInput from 'components/FormInput.jsx';
import PageControls from 'payments/components/PageControls.jsx';
import React from 'react';

import './styles/ActivityAnnouncementTitleForm.scss';

type Props = {
  onBack: () => void,
  onNext: (data: {title: string}) => void,
  title: ?string,
  placeholder: string,
};

type State = {
  title: string,
  isTitleValid: boolean,
};

class ActivityAnnouncementTitleForm extends React.Component {
  props: Props;

  state: State = {
    title: this.props.title || '',
    isTitleValid: false,
  };

  onTitleValid: Function = (): void => {
    if (!this.state.isTitleValid) {
      this.setState({ isTitleValid: true });
    }
  };

  onTitleInvalid: Function = (): void => {
    if (this.state.isTitleValid) {
      this.setState({ isTitleValid: false });
    }
  };

  onBack: Function = (): void => {
    this.props.onBack({
      title: this.state.title,
    });
  };

  onNext: Function = (): void => {
    this.props.onNext({
      title: this.state.title,
    });
  };

  onTitleChange: Function = (event): void => {
    this.setState({ title: event.target.value });
  };

  isValid: Function = (): boolean => {
    return this.state.isTitleValid;
  };

  render() {
    return (
      <div>
        <Form onValid={this.onTitleValid} onInvalid={this.onTitleInvalid}>
          <FormInput
            label="Name of activity"
            data-test="activity-announcement-title-and-participant-form-title"
            name="title"
            autoFocus
            autoComplete="off"
            required="isRequired"
            onChange={this.onTitleChange}
            placeholder={this.props.placeholder}
            validations={{ maxLength: 50 }}
            showErrorAfterBlur
            validationErrors={{
              isRequired: 'An activity name is required.',
              maxLength: 'The activity name can’t be longer than 50 characters.',
            }}
            value={this.props.title}
          />
        </Form>

        <PageControls
          className="ActivityAnnouncementTitleForm-controls"
          disabledNext={!this.isValid()}
          onBack={this.onBack}
          onNext={this.onNext}
        />
      </div>
    );
  }
}

export default ActivityAnnouncementTitleForm;



// WEBPACK FOOTER //
// ./src/payments/components/ActivityAnnouncementTitleForm.jsx